import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core'
import {Observable} from 'rxjs'

@Component({
  selector: 'app-dynamic-filters',
  templateUrl: './dynamic-filters.component.html',
  styleUrls: ['./dynamic-filters.component.scss'],
  standalone: false,
})
export class DynamicFiltersComponent implements OnInit {
  @Input() dynamicFilters$: Observable<any>
  @Output() removeDynamicFilter = new EventEmitter<{key: string}>()

  constructor() {}

  ngOnInit() {}

  onRemoveFilter(key: string) {
    this.removeDynamicFilter.emit({key: key})
  }
}
